import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Home from './pages/Home';
import Maintenance from './pages/Maintenance';
import Events from './pages/Events';
import Awards from './pages/Awards';
import Gallery from './pages/Gallery';

function App() {
  return (
      <Router>
        <Routes>
            {/* <Route path="/" element={<Maintenance />} /> */}
            {/* <Route path="/:code" element={<Home />} /> */}
            <Route path="/" element={<Home />} />
            <Route
              path="/events"
              element={ <Events /> }
            />
            <Route
              path="/awards"
              element={ <Awards /> }
            />
            <Route
              path="/gallery"
              element={ <Gallery /> }
            />
            <Route
              path="/maintenance"
              element={ <Maintenance /> }
            />
        </Routes>
      </Router>
  );
}

export default App;
